<template>
<div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

        <!-- Register v1 -->
        <b-card class="mb-0">
            <b-img thumbnail :src='detail.student.logo' fluid />
            <b-link class="brand-logo">

                <h2 class="brand-text text-primary">
                    {{ detail.student.client_name }}
                </h2>
            </b-link>

            <b-card-title class="mb-1">

            </b-card-title>
            <b-card-text class="mb-2">

            </b-card-text>

            <!-- form -->
            <validation-observer ref="registerForm">
                <h4 class="brand-text text-primary ml-1" v-if="valid === false">Invalid Link</h4>
                <b-form v-if="insert === false && valid === true">
                    <b-form-group label="Student Name 學生姓名" label-for="student_name">
                        <b-form-input id="student_name" v-model="detail.student.zh_name" trim readonly />

                    </b-form-group>

                    <b-form-group label="Mobile 聯絡電話" label-for="mobile">
                        <b-form-input id="mobile" v-model="detail.student.mobile" trim readonly />

                    </b-form-group>
                    <b-form-group label="Total Amount 應付金額" label-for="金額">
                        <b-input-group prepend="HKD">
                            <b-form-input readonly :value="formatAmount(detail.amount)" />
                        </b-input-group>
                    </b-form-group>

                    <b-form-group label="Prepaid Amount 已付金額" label-for="預付金額" v-if="detail.debit > 0">
                        <b-input-group prepend="HKD">
                            <b-form-input readonly :value="formatAmount(detail.debit)" />
                        </b-input-group>
                    </b-form-group>

                    <b-form-group label="Remaining Amount Payable 應付餘額" label-for="應付餘額">
                        <b-input-group prepend="HKD">
                            <b-form-input readonly :value="formatAmount(detail.amount - detail.debit)" />
                        </b-input-group>
                    </b-form-group>
                    <hr class="my-2" />
                    課程內容
                    <b-list-group>

                        <b-list-group-item class="flex-column align-items-start" v-for="detail in detail.classes" :key="detail.id">
                            <div class="d-flex w-100 justify-content-between">
                                <h5 class="mb-1">
                                    {{ detail.name }}
                                </h5>
                                <small class="text-secondary">HKD ${{ detail.price}} / session</small>
                            </div>
                            <ul>
                                <li v-for="enrollment in detail.enrollments" :key="detail.id"> <b>{{ enrollment.formatted_date }} </b> {{ enrollment.start }}-{{ enrollment.end }} <span v-if="admin === true">( #{{ enrollment.id }} )</span></li>
                            </ul>

                            <small class="text-secondary" variant="danger" v-if="detail.leave > 0">上月請假日數 : {{ detail.leave }}日</small>
                        </b-list-group-item>

                    </b-list-group>

                    <!-- submit button -->
                    <!-- <b-button variant="primary" :disabled="paid" class="mt-2" block type="button" @click="submit_payment()">
                        Submit Payment
                    </b-button> -->
                    <div v-if="admin === true">
                    <hr />
                    <v-select
                        v-model="selected_payment.method"
                        :options="paymentMethods"
                        :reduce="method => method.value"
                        input-id="payment-method"
                        class="payment-selector"
                        :clearable="false"
                        />
                        <b-form-input type="text" class="mt-1"  v-model="selected_payment.amount" placeholder="金額 Amount" />
                    <b-button v-if="admin === true" variant="danger" :disabled="paid" class="my-2 mb-5" block type="button" @click="submit_payment()">
                        Approve By Admin
                    </b-button>
                    </div>
                </b-form>
            </validation-observer>

        </b-card>
        <!-- /Register v1 -->
    </div>
</div>
</template>

  
  
<script>
import {
    ValidationProvider,
    ValidationObserver
} from 'vee-validate'
import vSelect from 'vue-select'

import {
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BImg,
    BRow,
    BListGroup,
    BListGroupItem,
    BCol,
    BBadge,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
} from 'bootstrap-vue'
import router from '@/router'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
    required,
    email
} from '@validations'
import {
    togglePasswordVisibility
} from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        VuexyLogo,
        BListGroup,
        BListGroupItem,
        vSelect,
        // BSV
        BCard,
        BBadge,
        BRow,
        BCol,
        BImg,
        BLink,
        BCardTitle,
        router,
        BCardText,
        BForm,
        BButton,
        BFormInput,
        BFormGroup,
        BInputGroup,
        BInputGroupAppend,
        BFormCheckbox,
        // validations
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            paymentMethods: [ {value:'ONLINE',label:'Online'},{value:'CASH',label:'Cash'},{value:'FPS',label:'轉數快'},{value:'PAYME',label:'PayMe'},{value:'Chueqe',label:'支票'}],
            regEmail: '',
            qfpay: null,
            selected_payment: {
                method: 'ONLINE',
                amount: 0
            },
            detail: null,
            username: '',
            valid: true,
            password: '',
            admin: false,
            status: '',
            insert: false,
            paid: false,
            member: {
                member_code: null,
                mobile: null
            },
            card: {
                number: null,
                expire: null,
                cvc: null,
                center_id: router.currentRoute.params.center_id
            },
            // validation rules
            required,
            email,
        }
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
    },
    created() {
        this.get_detail()
        if (this.$route.query.role == 'admin') {
            this.admin = true;
        }
    },
    methods: {
          formatAmount(value) {
          return Number(value).toFixed(2);
        },
        submit_payment() {
           
            if (this.detail.amount == 0 || this.admin === true) {
                this.$http.post(process.env.VUE_APP_API_BASE + '/payment_gateway/free-transaction/' + router.currentRoute.params.student_uuid + '/' + router.currentRoute.params.date + '/', { detail : this.detail,payment: this.selected_payment })
                    .then(res => {
                        if (res.data.result === true) {
                            this.$swal({
                                title: 'Success!',
                                text: 'Payment has been processed successfully!',
                                icon: 'success',
                                showConfirmButton: false,
                                buttonsStyling: false,
                                backdrop: false,
                            })
                            this.paid = true
                        }
                        return
                        window.location.href = res.data.url
                    })
            } else {
                this.detail.payment_target = router.currentRoute.params.date
                this.$http.post(process.env.VUE_APP_API_BASE + '/payment_gateway/qfpay-sdk/', this.detail)
                    .then(res => {
                        this.qfpay = res.data
                        window.location.href = this.qfpay.url
                    })
            }
        },
        get_detail() {
            this.$http.get(process.env.VUE_APP_API_BASE + `/schedule-payment/` + router.currentRoute.params.student_uuid + `/` + router.currentRoute.params.date + `/`)
                .then(res => {
                    if (res.data.result === false) {
                        this.valid = false
                    } else {
                        this.detail = res.data
                    }
                })
        },
        add_card() {
            this.$http.post(process.env.VUE_APP_API_BASE + '/member/token/' + router.currentRoute.params.token + '/credit_card/add/', this.card)
                .then(res => {
                    if (res.data.result === true) {
                        this.insert = true
                        this.card.number = null
                        this.card.expire = null
                        this.card.cvc = null
                        this.$swal({
                            title: 'Success!',
                            text: 'You inserted a valid credit card!',
                            icon: 'success',
                            showConfirmButton: false,
                            buttonsStyling: false,
                            backdrop: false,
                        })
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
    },
}
</script>
  
  
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
